const BASE_URL = "https://api.shubhamraj01.in";

const getHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const getCategories = async (jwt) => {
  const res = await fetch(`${BASE_URL}/api/category/restaurant`, {
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error("Categories nahi mili");
  return res.json();
};

export const createCategory = async (name) => {
  const res = await fetch(`${BASE_URL}/api/admin/category`, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify({ name }),
  });
  if (!res.ok) throw new Error("Category create failed");
  return res.json();
};

export const getIngredients = async (restaurantId) => {
  const res = await fetch(
    `${BASE_URL}/api/admin/ingredients/restaurant/${restaurantId}`,
    { headers: getHeaders() }
  );
  if (!res.ok) throw new Error("Ingredients nahi mile");
  return res.json();
};

export const createFood = async (foodData) => {
  const res = await fetch(`${BASE_URL}/api/admin/food`, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(foodData),
  });
  if (!res.ok) throw new Error("Food create failed");
  return res.json();
};

export const deleteFood = async (id) => {
  const res = await fetch(`${BASE_URL}/api/admin/food/${id}`, {
    method: "DELETE",
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error("Food delete failed");
  return res.json();
};

export const toggleFoodAvailability = async (id) => {
  const res = await fetch(`${BASE_URL}/api/admin/food/${id}`, {
    method: "PUT",
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error("Toggle failed");
  return res.json();
};